
import { useCallback, useState, useContext, useEffect } from "react";
import { getEmployeeRequestDefaultNotification, addEmployeeRequestDefaultNotification, deleteEmployeeRequestDefaultNotification } from "../TicketManagement/TicketService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { debounce } from "lodash";
import { InputText } from "primereact/inputtext";

const EmployeeRequestDefaultNotification = () => {
  const [columns, setColumns] = useState(["DefaultMailbox"]); 
  const [rows, setRows] = useState([{}]);
  const [editIndex, setEditIndex] = useState(null);
  const [empReqDefaultNotification,setEmpReqDefaultNotification] = useState([]);
  const [selectedId, SetSelectedId] = useState();
  const defaultImage = "/images/placeholder_profile.png";
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [empReqDefaultAssignmentId, setEmpReqDefaultAssignmentId] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  let toster = useContext(TostMsg);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({
    DefaultMailbox: "",
  });
  let SearchValue = "";

  useEffect(() => {
    GetEmpReqDefaultNotification();
  }, []);

  const validateEmpRequestDefaultNotifications = (data, index) => {
    const newErrors = {};
    newErrors[`${index}-DefaultMailbox`] =
      !data.DefaultMailbox || data.DefaultMailbox.trim() === ""
        ? "DefaultMailbox"
        : undefined;
    setErrors((prev) => ({ ...prev, ...newErrors }));
    const isValid = Object.values(newErrors).every(
      (error) => error === undefined
    );
    return isValid;
  };

  async function GetEmpReqDefaultNotification() { 
    setIsloading(true);
    try {
      let responce = await getEmployeeRequestDefaultNotification({});
      setEmpReqDefaultNotification(responce?.Data);
    } catch (err) {
      // toster.current.error(ERROR_LIST.AwardMasterData);
    } finally {
      setIsloading(false);
    }
  }
  // Add a new row
  const handleAddRow = () => {
    setEmpReqDefaultNotification([
      ...empReqDefaultNotification,
      { Name: "", Description : ""},
    ]);
    setEditIndex(empReqDefaultNotification.length); 
  };

  // Delete the last row
  const handleRemoveRow = () => {
    setRows(rows.slice(0, -1));
  };

  // Remove a specific row
  const handleRemoveSpecificRow = (rowIdx) => () => {
    const updatedRows = rows.filter((_, idx) => idx !== rowIdx);
    setRows(updatedRows);
  };

  const handleChange = (rowIdx, colName) => (e) => {
  const { value } = e.target;
  setEmpReqDefaultNotification(prevList => {
    const newList = prevList.map((item, idx) =>
      idx === rowIdx ? { ...item, [colName]: value } : item
    );
    return newList;
  });
  setData(prev => ({ ...prev, [colName]: value }));
  validateEmpRequestDefaultNotifications({ ...empReqDefaultNotification[rowIdx], [colName]: value }, rowIdx);
};

  const cancelOrgWfh = () => {
  GetEmpReqDefaultNotification();
  setEmpReqDefaultNotification(prevList => {
    setEditIndex(null);
    const len = prevList.length;
    if (len === 0) return prevList;

    const lastItem = prevList[len - 1];
    const isEmpty = lastItem &&
      !lastItem.DefaultMailbox;
      
    if (isEmpty) {
      return prevList.slice(0, -1);
    }
    return prevList;
  });
}
  async function addEmpReqDefaultNotification(index, data) {
    const body = {
    Id: data?.Id || 0,
    OrgId: userDetails?.OrgId,
  DefaultMailbox: data.DefaultMailbox
    };
    try {
      await addEmployeeRequestDefaultNotification(body);
      if (empReqDefaultAssignmentId) {
        alert('Notification Updated');
      } else {
        alert('Notification Added');
      }
      SetSelectedId(null);
      setEmpReqDefaultNotification([]);
      setEditIndex(null);
      GetEmpReqDefaultNotification();
      setIsloading(false);
    } catch (err) {
      setIsloading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleEditClick = (index) => {
    setEditIndex(index);
  };

  const handleEmpReqCategory = (Id) => {
    setEmpReqDefaultAssignmentId(Id);
  };

   async function DeleteOrgEmpRequestDefaultNotifications() {  
      setIsloading(true);
      if (empReqDefaultAssignmentId) {
        let body = {
          Id: empReqDefaultAssignmentId,
        };
        try {
          let empReqCategoryList = await deleteEmployeeRequestDefaultNotification(body);
          if (empReqCategoryList) {
            setIsloading(false);
            GetEmpReqDefaultNotification();
          }
        } catch (error) {
          toster.current.error(ERROR_LIST.DefaultError);
        }
      }
    }

  const handleInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      SearchValue = value;
      let filteredList = empReqDefaultNotification.filter((orgReqStatus) =>
        orgReqStatus.DefaultMailbox?.toLowerCase().includes(SearchValue?.toLowerCase())
      );
      if (SearchValue != "") {
        setEmpReqDefaultNotification(filteredList);
      } else {
        GetEmpReqDefaultNotification();
      }
    }, 800),
    [empReqDefaultNotification]
  );

  return (
    <div className="setting-detail-list">
      <div className="detail award-detail">
        <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4">
        </div>
        <div className="title-text">
          <h3>Employee Request Default Notifications ({empReqDefaultNotification?.length})</h3>
          <div className="d-flex">
          <InputText
            name="requestTitle"
            className="form-control search-grpname me-2"
            onChange={handleInputChange}
            placeholder="Search"
          />

          {!editIndex && (
            <button
              className="addaward-btn"
              data-toggle="tooltip"
              data-placement="top"
              title=""
              data-bs-original-title=""
              fdprocessedid="izng1j"
              onClick={handleAddRow}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-plus"
                viewBox="0 0 16 16"
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
              </svg>
              Default Notifications
            </button>
          )}
          </div>
        </div>


        <div className="col-md-12 column">
          <table className="table table-bordered table-hover" id="tab_logic">
            <thead>
              <tr>
                {columns.map((colName, colIdx) => (
                  <th key={colIdx} className="text-left">
                    {colName}
                  </th>
                ))}
                <th className="text-left" style={{ width: "100px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {empReqDefaultNotification?.map((data, index) => (
                <tr key={index}>
                  
                  {editIndex === index ? (
                    <>
                      <td>
                        <input
                          type="text"
                          value={data.DefaultMailbox}
                          onChange={handleChange(index, "DefaultMailbox")}
                          placeholder="Default Mailbox"
                          className={`form-control ${errors[`${index}-DefaultMailbox`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-DefaultMailbox`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-DefaultMailbox`]}
                          </div>
                        )}
                      </td>
                      
                      <td>
                        <>
                          <img
                            onClick={() => {
                              cancelOrgWfh();
                            }}
                            src="/images/org-img/profile/close.png"
                            title="Cancel"
                            className="editactions me-2"
                            style={{ width: "17px" }}
                          />
                          <img
                            src="/images/org-img/profile/check.png"
                            title="Confirm"
                            className="editactions"
                            style={{ width: "17px" }}
                            onClick={() => {
                            if (validateEmpRequestDefaultNotifications(data, index)) { 
                            addEmpReqDefaultNotification(index, data);
                            setEditIndex(null);
                            }
                           }}
                          />
                        </>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{data?.DefaultMailbox}</td>
                      <td className="">
                        <button
                          disabled={editIndex != null}
                          className="editactions me-2"
                          onClick={() => handleEditClick(index)}
                        >
                          <img
                            src="/images/tickets/edit-ico.svg"
                            className=""
                            title="Edit"
                          />
                        </button>

                        <button
                          className="editactions"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-emp-req-default-notification"
                          onClick={() => {
                            handleEmpReqCategory(data?.Id);
                            // GetMasterSystemAlertList("Delete_Award", 1);
                          }}
                        >
                          <img
                            src="/images/tickets/delete.svg"
                            className=""
                            title="Delete"
                          />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal fade " id="delete-emp-req-default-notification">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />                
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                {/* <p>{deleteContent}</p> */}
                <p>Do you really want to delete this Employee Request Default Notifications?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => DeleteOrgEmpRequestDefaultNotifications()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EmployeeRequestDefaultNotification;
